var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { Dialog } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { generateBoleto, getBoleto, } from "../../apis/api";
import { calcDataVencimento, formatCurrency, formatForPayload, getPeriodoReferencia, paddingCpfCnpj, } from "../../util/utilitarios";
import { toast } from "react-toastify";
import Loader from "../Loading";
var BootstrapDialog = styled(Dialog)(function (_a) {
    var theme = _a.theme;
    return ({
        "& .MuiDialogContent-root": {
            padding: theme.spacing(2),
        },
        "& .MuiDialogActions-root": {
            padding: theme.spacing(1),
        },
    });
});
function BootstrapDialogTitle(props) {
    var children = props.children, onClose = props.onClose, other = __rest(props, ["children", "onClose"]);
    return (_jsxs(DialogTitle, __assign({ sx: { m: 0, p: 1, backgroundColor: "#034EA2", color: "white" } }, other, { children: [children, onClose ? (_jsx(IconButton, __assign({ "aria-label": "close", onClick: onClose, sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: "white",
                } }, { children: _jsx(CloseIcon, {}) }))) : null] })));
}
export function DialogQuitarParcelas(props) {
    var handleClose = props.handleClose;
    var debitos = props.debitos;
    var dataUser = props.dataUser;
    var renavam = props.renavam;
    var _a = React.useState(true), open = _a[0], setOpen = _a[1];
    var _b = React.useState(0), numeroParcelas = _b[0], setNumerosParcelas = _b[1];
    var _c = React.useState(0), valorPrincipal = _c[0], setValorPrincipal = _c[1];
    var _d = React.useState(0), valorMulta = _d[0], setValorMulta = _d[1];
    var _e = React.useState(0), valorJuros = _e[0], setValorJuros = _e[1];
    var _f = React.useState(0), valorAtualizacao = _f[0], setValorAtualizacao = _f[1];
    var _g = React.useState(false), listarValores = _g[0], setListaValores = _g[1];
    var _h = React.useState(0), somaValores = _h[0], setSomaValores = _h[1];
    var _j = React.useState(false), loading = _j[0], setLoading = _j[1];
    function handleGerarBoleto() {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var periodoReferencia, debito, payload, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setLoading(true);
                        periodoReferencia = getPeriodoReferencia();
                        debito = __assign({}, debitos[0]);
                        payload = {
                            codigoReceita: debito.codigoReceita,
                            cpfCnpjRenavan: paddingCpfCnpj(dataUser.conteudoSaida.conteudoSaida.proprietario.cpfCnpjRenavan),
                            numeroDocumento: debito.numeroDocumento || "0",
                            numeroParcela: 1,
                            periodoReferencia: numeroParcelas !== 1 ? periodoReferencia : debitos[0].periodoReferencia,
                            renavam: renavam,
                            valorTotal: formatForPayload(somaValores),
                            dataVencimento: calcDataVencimento(debito.dataVencimento),
                            valorPrincipal: formatForPayload(valorPrincipal),
                            juros: formatForPayload(valorJuros),
                            multa: formatForPayload(valorMulta),
                            isencaoLei7995: (_a = debito.isencaoLei7995) === null || _a === void 0 ? void 0 : _a.trim(),
                        };
                        return [4 /*yield*/, getBoleto(payload, dataUser.conteudoSaida.conteudoSaida.placa)];
                    case 1:
                        result = _b.sent();
                        if ((result === null || result === void 0 ? void 0 : result.codigoBarras) === undefined) {
                            toast.error("Erro gerar dar! Tente novamente");
                            setLoading(false);
                            return [2 /*return*/];
                        }
                        debito.valorPrincipal = valorPrincipal;
                        debito.juros = valorJuros;
                        debito.multa = valorMulta;
                        debito.total = somaValores;
                        debito.periodoReferencia =
                            numeroParcelas !== 1 ? periodoReferencia : debitos[0].periodoReferencia;
                        debito.numeroParcela = numeroParcelas === 1 ? debito.numeroParcela : 0;
                        // debito.dataVencimento = debitos[Number(numeroParcelas) - 1].dataVencimento;
                        debito.numeroParcela = numeroParcelas === 1 ? debito.numeroParcela : 0;
                        return [4 /*yield*/, generateBoleto(debito, dataUser, (result === null || result === void 0 ? void 0 : result.tokenBoleto) || "")];
                    case 2:
                        _b.sent();
                        setLoading(false);
                        handleDialogClose();
                        return [2 /*return*/];
                }
            });
        });
    }
    var handleDialogClose = function () {
        setOpen(false);
        handleClose();
    };
    React.useEffect(function () {
        function handleValores() {
            var parcelasParaPagamento = debitos;
            setValorPrincipal(parcelasParaPagamento.reduce(function (accumulator, current) { return accumulator + current.valorPrincipal; }, 0));
            setValorJuros(parcelasParaPagamento.reduce(function (accumulator, current) { return accumulator + current.juros; }, 0));
            setValorMulta(parcelasParaPagamento.reduce(function (accumulator, current) { return accumulator + current.multa; }, 0));
            setValorAtualizacao(parcelasParaPagamento.reduce(function (accumulator, current) { return accumulator + current.atualizacao; }, 0) || 0);
            setListaValores(true);
        }
        handleValores();
        // setListaValores(true);
        setSomaValores(valorPrincipal + valorJuros + valorMulta + valorAtualizacao);
    }, [valorPrincipal, valorJuros, valorMulta, valorAtualizacao]);
    return (_jsx(_Fragment, { children: _jsxs(BootstrapDialog, __assign({ onClose: handleDialogClose, "aria-labelledby": "customized-dialog-title", open: open, sx: {} }, { children: [_jsx(Loader, { open: loading, sx: { color: "#fff" }, zIndex: 999 }), _jsx(BootstrapDialogTitle, __assign({ id: "customized-dialog-title", onClose: handleClose }, { children: "Quitar Parcelamento" })), _jsxs(DialogContent, __assign({ dividers: true }, { children: [_jsx(Typography, __assign({ gutterBottom: true, fontWeight: "bold" }, { children: "Aten\u00E7\u00E3o" })), _jsx(Typography, __assign({ gutterBottom: true }, { children: "O pagamento gerado por esta op\u00E7\u00E3o quitar\u00E1 o d\u00E9bito existente" })), _jsx(Typography, { gutterBottom: true }), _jsx("div", { style: {
                                marginTop: 20,
                                marginBottom: 20,
                                fontWeight: "bold",
                            } }), _jsxs(_Fragment, { children: [_jsxs("div", { children: [_jsxs("div", __assign({ style: item }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", gutterBottom: true }, { children: "Valor Principal:" })), _jsx("span", __assign({ style: itemInfo }, { children: _jsx(Typography, { children: formatCurrency(valorPrincipal) }) }))] })), _jsxs("div", __assign({ style: item }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", gutterBottom: true }, { children: "Juros:" })), _jsx("span", __assign({ style: itemInfo }, { children: _jsx(Typography, { children: formatCurrency(valorJuros) }) }))] })), _jsxs("div", __assign({ style: item }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", gutterBottom: true }, { children: "Multa:" })), _jsx("span", __assign({ style: itemInfo }, { children: _jsx(Typography, { children: formatCurrency(valorMulta) }) }))] })), _jsxs("div", __assign({ style: item }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", gutterBottom: true }, { children: "Atualiza\u00E7\u00E3o:" })), _jsx("span", __assign({ style: itemInfo }, { children: _jsx(Typography, { children: formatCurrency(valorAtualizacao) }) }))] })), _jsxs("div", __assign({ style: item }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", gutterBottom: true }, { children: "Total a Pagar:" })), _jsx("span", __assign({ style: itemInfo }, { children: _jsx(Typography, { children: formatCurrency(somaValores) }) }))] }))] }), _jsxs("div", __assign({ style: grupoButtoes }, { children: [_jsx(Button, __assign({ sx: {
                                                backgroundColor: "#034EA2",
                                                color: "white",
                                            }, onClick: function () { return handleGerarBoleto(); } }, { children: "Gerar Boleto" })), _jsx(Button, __assign({ sx: {
                                                backgroundColor: "#E4E4E4",
                                                color: "black",
                                            }, onClick: function () { return handleDialogClose(); } }, { children: "Cancelar" }))] }))] })] }))] })) }));
}
var itemInfo = {
    marginLeft: 10,
};
var item = {
    marginBottom: 5,
    fontSize: 18,
    display: "flex",
};
var grupoButtoes = {
    marginTop: 15,
    display: "flex",
    justifyContent: "space-between",
};
